import React, { useState } from 'react';
import classnames from 'classnames';

import ZoneJobDistrib from '../ZoneJobDistrib';
import LegendItem from '../LegendItem';

import { category10 } from '../../helpers/colors';
import pieChartFields from '../../schemas/pie-chart-fields.json';

import styles from './JobDistrib.module.scss';

const pieChartFieldsArray = Object.keys(pieChartFields);
const colorBy = ({ id }) => category10[pieChartFieldsArray.findIndex(field => field === id)];

const JobDistrib = ({ zones = [] }) => {
  const [active, setActive] = useState({});

  const mouseEnter = node => setActive(node);
  const mouseLeave = () => setActive({});

  return (
    <>
      <div className={styles.repartition}>
        {zones.map(zone => (
          <ZoneJobDistrib
            active={active.id}
            key={zone.id_eae}
            zone={zone}
            showLabels={zones.length <= 2}
            onMouseEnter={mouseEnter}
            onMouseLeave={mouseLeave}
            style={{ width: `calc(100% / ${zones.length})` }}
          />
        ))}
      </div>

      {zones.length > 1 && (
        <div className={classnames(styles.pieLegend, { [styles.haveActiveItem]: !!active })}>
          {pieChartFieldsArray.map(field => (
            <LegendItem
              key={field}
              color={colorBy({ id: field })}
              className={classnames({
                [styles.pieLegendItem]: true,
                [styles.active]: active.id === field,
              })}
              onMouseEnter={() => mouseEnter({ id: field })}
              onMouseLeave={mouseLeave}
            >
              {pieChartFields[field].label}
            </LegendItem>
          ))}
        </div>
      )}
    </>
  );
};

export default JobDistrib;
